import { useCallback } from 'react';

import { useNavigateRoute } from 'src/components/Router/useNavigateRoute';

export const useEnterReadMode = () => {
  const navigate = useNavigateRoute();

  return useCallback(() => {
    navigate({}, { replace: true });
  }, [navigate]);
};
